export const isExternal = (path) => /^(https?:|mailto:|tel:)/.test(path);
export const isArray = (arg) => {
    if (typeof Array.isArray === "undefined") {
        return Object.prototype.toString.call(arg) === "[object Array]";
    }
    return Array.isArray(arg);
};
export const isValidURL = (url) => {
    const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
    return reg.test(url);
};
const _now = new Date();
/**
 * 检验日期是否禁用
 * @param date 日期 符合校验规则则禁用
 * @param type 检验规则 upper大于基准 lower小于基准
 * @param compareDate 基准日期 不填则默认为当前时间
 * @returns 是否禁用
 */
export const isDateDisabled = (date, type = "upper", compareDate) => {
    if (typeof date === "string")
        date = new Date(date);
    if (!compareDate)
        compareDate = _now;
    else if (typeof compareDate === "string")
        compareDate = new Date(compareDate);
    if (type === "upper") {
        return date > compareDate;
    }
    else if (type === "lower") {
        return date < compareDate;
    }
    else {
        return date === compareDate;
    }
};
